<template>
  <div>
    <v-layout row>
       <v-flex xs7>
          <h2>Баланс</h2>
        </v-flex>
       <v-flex xs5 >
          <span >ЛС {{Account.num}}  </span>
          <router-link :to="{name:'История счета'}" text-right>История операций</router-link>
        </v-flex>
    </v-layout>
    <v-container class="elevation-1 my-2">
      <v-layout justify-start row wrap>
        <v-flex xs7 sm4 md2>
          <div primary-title>{{Account.sum_balance}} р.</div>
          <div class="labelsum">свободно</div>
        </v-flex>
        <v-flex xs7 sm4 md2>
          <div primary-title>{{Account.sum_invested}} р.</div>
          <div class="labelsum">инвестировано</div>
        </v-flex>
        <v-flex xs7 sm4 md2>
          <div primary-title>{{Account.sum_locked}} р.</div>
          <div class="labelsum">резерв</div>
        </v-flex>
        <v-flex xs12  md6>
          <v-layout align-center justify-space-around row wrap>
            <v-flex xs12 sm5>
              <v-btn outline block @click="fund(Account.id)">Пополнить счет</v-btn>
            </v-flex>
            <v-flex xs12 sm5>
              <v-btn outline block @click="withdraw(Account.id)">Вывести деньги</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

</template>

<script>

export default {
    created () {

    },
    mounted () {
    },
    computed: {
      Account() {
       return this.$store.state.account.account;
     }
    },
    data () {
        return {
        }
    },
    methods: {
      fund(id) {
        console.log('fund',id);
        this.$router.push('/fund-account')
      },
      withdraw(id) {
        console.log('withdraw',id);
        this.$router.push('/withdraw-account')
      }
    }
}
</script>

<style>

    .labelsum {
      color: grey;
      font-size: smaller
    }
</style>



// WEBPACK FOOTER //
// BalanceBox.vue?957a45cc